import { Datatable } from '../../component/Datatable/Datatable';
import { GridColDef } from '@mui/x-data-grid';

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'code', headerName: 'Код', width: 130 },
  { field: 'title', headerName: 'Назва товару', width: 130 },
  { field: 'size', headerName: 'Розмір', width: 130 },
  { field: 'price', headerName: 'Ціна', width: 130 }
];

const rows = [
  { id: 1, code: '1000', title: 'Кофта біла', size: 'XL', price: 250 },
  { id: 2, code: '1001', title: 'Блузка', size: 'XL', price: 650 },
  { id: 3, code: '1002', title: 'Блузка', size: 'L', price: 450 }
];

const Products: React.FunctionComponent = () => {
  return (
    <>
      <Datatable columns={columns} rows={rows} />
    </>
  );
};

export { Products };
